/**
 * Encryption of login challenge payload.
 */

import { CryptoContext } from '../base';
import { LoginChallengeConfigDumpArgs, LoginChallengeConfigLoadArgs } from './args';
import { LoginChallengeConfigV1 } from './v1';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';
import { LoginChallengeConfigV2 } from './v2';

export let LOGIN_CHALLENGE_CRYPTO_CONTEXT = new CryptoContext<
  LoginChallengeConfigLoadArgs,
  LoginChallengeConfigDumpArgs
>(
  [new LoginChallengeConfigV1(CU_ANNULLED_BY_PQC_ML), new LoginChallengeConfigV2(CU_PQC_ML)],
  [new Uint8Array([1])]
);
